import axios from 'axios';


export const getShiftWorkbenchTemplate=() =>{
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-template`
  );
}
export const AddShiftWorkbenchTemplate=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-template/create`,
    obj,
    { headers }
  );
}

export const EditShiftWorkbenchTemplate=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-template/edit`,
    obj,
    { headers }
  );
}

export const DeleteShiftWorkbenchTemplate=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-template/delete`,
    obj,
    { headers }
  );
}